export const security = {
  complexity: [{
    value: '1', label: '长度至少8位', score: 10
  }, {
    value: '2', label: '长度至少8位，必含大小写字母', score: 15
  }, {
    value: '3', label: '长度至少8位，必含数字、大小写字母', score: 30
  }],
  frequency: [{
    value: '0', label: '不限制', score: 0
  }, {
    value: '120', label: '120天', score: 5
  }, {
    value: '90', label: '90天', score: 15
  }, {
    value: '60', label: '60天', score: 30
  }],
  repeat: [{
    value: '1', label: '1次', score: 0
  }, {
    value: '3', label: '3次', score: 3
  }, {
    value: '5', label: '5次', score: 5
  }, {
    value: '0', label: '不允许重复', score: 10
  }],
  multiple: [{
    value: '1', label: '启用'
  }, {
    value: '0', label: '禁用'
  }],
  userRegisterApproveType: [{
    value: '0', label: '无需审核'
  }, {
    value: '1', label: '需要审核'
  }]
}

export default {
  security
}



// WEBPACK FOOTER //
// ./src/data/security.js